import React, { Component } from 'react'

 class FormLabel extends Component {
   constructor(props){
     super(props)
   }
  render() {
    return (
    <label htmlFor={this.props.htmlFor} className="label">{this.props.title}</label>
    )
  }
}
export default FormLabel;